import React from 'react';
import { Card, CardContent } from './ui/card';
import { Gift, RefreshCw, Zap, Users } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const DifferentialsSection = () => {
  const { t } = useLanguage();

  const differentials = [
    {
      icon: <Gift className="w-8 h-8" />,
      title: t('differentials.prediscovery.title'),
      description: t('differentials.prediscovery.description'),
      color: "primary"
    },
    {
      icon: <RefreshCw className="w-8 h-8" />,
      title: t('differentials.endtoend.title'),
      description: t('differentials.endtoend.description'),
      color: "secondary"
    },
    {
      icon: <Zap className="w-8 h-8" />,
      title: t('differentials.agile.title'),
      description: t('differentials.agile.description'),
      color: "primary"
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: t('differentials.exclusive.title'),
      description: t('differentials.exclusive.description'),
      color: "secondary"
    }
  ];

  return (
    <section id="diferenciais" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('differentials.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('differentials.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {differentials.map((differential, index) => (
            <Card 
              key={index}
              className="group hover:shadow-xl transition-all duration-300 border-0 shadow-lg hover:-translate-y-2"
            >
              <CardContent className="p-6 text-center">
                <div className={`w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 ${
                  differential.color === 'primary' 
                    ? 'bg-primary/10 text-primary group-hover:bg-primary/20' 
                    : 'bg-secondary/10 text-secondary group-hover:bg-secondary/20'
                }`}>
                  {differential.icon}
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  {differential.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {differential.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-primary/5 to-secondary/5 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              {t('differentials.cta.title')}
            </h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              {t('differentials.cta.subtitle')}
            </p>
            <button 
              onClick={() => document.getElementById('contato').scrollIntoView({ behavior: 'smooth' })}
              className="bg-primary hover:bg-primary/90 text-white px-8 py-3 rounded-lg font-medium transition-colors duration-300"
            >
              {t('differentials.cta.button')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};